import type { SellerDashboardResponse } from '@troia-v3/types';

import { api, type ApiResponse } from '@/lib/api';

import type { SellerPeriodValue } from '../lib/sellerFormat';

/**
 * Query do período: pronto → `period`; personalizado → `period=custom` +
 * `startDate`/`endDate` como dias crus `yyyy-mm-dd` — quem aplica o fuso da
 * empresa é o backend, igual aos períodos prontos.
 */
export function sellerDashboardParams(period: SellerPeriodValue): Record<string, string> {
  if (period.mode !== 'custom') return { period: period.mode };
  return {
    period: 'custom',
    ...(period.start ? { startDate: period.start } : {}),
    ...(period.end ? { endDate: period.end } : {}),
  };
}

/** Backend: GET /api/leads/seller-dashboard?period=today|week|month|custom (permissão crm:read). */
export const sellerDashboardApi = {
  async get(period: SellerPeriodValue): Promise<SellerDashboardResponse> {
    const response = await api.get<ApiResponse<SellerDashboardResponse>>('/leads/seller-dashboard', { params: sellerDashboardParams(period) });
    return response.data.data!;
  },
};
